
  import { Vue, Component } from "vue-property-decorator";

  import FormWrapper from "@/components/form/FormWrapper.vue";
  import FormGroup from "@/components/form/FormGroup.vue";
  import UiButton from '@/components/button/ui-button.vue';

  import auth from "@/services/auth";

  import Message from "@/data/notificationsMessages";
  import { NOTIFICATION } from "@/entities/Events";

  interface Observer extends Vue {
    reset: Function;
  }

  @Component({
    components: {
      FormWrapper,
      FormGroup,
      UiButton,
    },
  })
  export default class PasswordSettings extends Vue {
    processing: boolean = false;

    currentPassword: string = "";

    newPassword: string = "";
    
    confirmPassword: string = "";

    async resetPassword(): Promise<void> {
      this.processing = true;
      
      try {
        await auth.changePassword(this.currentPassword, this.newPassword);
        this.$eventBus.emit(NOTIFICATION, Message.successMessage("Your password has been updated"));
      } catch (error) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(error.message));
      } finally {
        (this.$refs.observer as Observer).reset();
        this.processing = false;
        this.reset();
      }
    }

    reset(): void {
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
    }
  }
